/* Creator-Landingpages — Rabattcode kopieren, Zwei-Klick-Embeds, Sticky-Leiste.
   Vanilla JS, defensiv: jeder Block prueft sein Zielelement und bricht sonst still ab. */
(function () {
  'use strict';

  // Mehrere Sections binden dieses Script ein -- nur einmal initialisieren.
  if (window.__creatorLandingLoaded) return;
  window.__creatorLandingLoaded = true;

  /* ---------------------------------------------------------------- Copy */

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    // Fallback fuer aeltere Browser / unsichere Kontexte
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (e) {
        reject(e);
      } finally {
        document.body.removeChild(ta);
      }
    });
  }

  function initCopyButtons() {
    document.querySelectorAll('[data-creator-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-creator-copy');
        var feedback = document.getElementById(btn.getAttribute('aria-describedby') || '');
        if (!code) return;

        copyText(code).then(function () {
          if (feedback) feedback.textContent = feedback.getAttribute('data-success') || 'Kopiert!';
        }).catch(function () {
          if (feedback) feedback.textContent = feedback.getAttribute('data-error') || '';
        });

        if (feedback) {
          window.clearTimeout(btn._creatorTimer);
          btn._creatorTimer = window.setTimeout(function () { feedback.textContent = ''; }, 4000);
        }
      });
    });
  }

  /* ------------------------------------------------- Zwei-Klick-Embeds */

  function buildFrame(type, id, ratio) {
    var src;
    if (type === 'youtube') {
      // nocookie-Domain: kein Tracking-Cookie vor der Wiedergabe
      src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    } else if (type === 'instagram') {
      src = id.replace(/\/?$/, '/') + 'embed';
    } else if (type === 'spotify') {
      // aus .../episode/ID wird .../embed/episode/ID
      src = id.replace('open.spotify.com/', 'open.spotify.com/embed/');
      if (src.indexOf('open.spotify.com/embed/') === -1) return null;
    } else if (type === 'tiktok') {
      var m = id.match(/video\/(\d+)/);
      if (!m) return null;
      src = 'https://www.tiktok.com/embed/v2/' + m[1];
    } else {
      return null;
    }

    var frame = document.createElement('iframe');
    frame.className = 'creator-embed__frame';
    if (type === 'spotify') frame.setAttribute('data-ratio', 'audio');
    if (ratio) frame.setAttribute('data-ratio', ratio);
    frame.setAttribute('src', src);
    frame.setAttribute('loading', 'lazy');
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('allow', 'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    frame.setAttribute('title', 'Eingebettetes Video');
    return frame;
  }

  function initEmbeds() {
    document.querySelectorAll('[data-creator-embed]').forEach(function (button) {
      button.addEventListener('click', function () {
        var wrapper = button.closest('.creator-embed');
        if (!wrapper) return;
        var frame = buildFrame(
          button.getAttribute('data-creator-embed'),
          button.getAttribute('data-embed-id') || '',
          button.getAttribute('data-ratio') || ''
        );
        if (!frame) return;
        wrapper.replaceChild(frame, button);
      }, { once: true });
    });
  }

  /* -------------------------------------------------- Sticky-Codeleiste */

  function initSticky() {
    var bar = document.querySelector('[data-creator-sticky]');
    if (!bar) return;

    var anchor = document.getElementById('creator-products');
    var dismissed = false;

    var closeBtn = bar.querySelector('[data-creator-sticky-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dismissed = true;
        bar.classList.remove('is-visible');
      });
    }

    if (!('IntersectionObserver' in window) || !anchor) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (dismissed) return;
        bar.classList.toggle('is-visible', entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -20% 0px' }).observe(anchor);
  }

  /* ------------------------------------- Inaktive Seite aus dem Index halten */

  function initNoindex() {
    if (!document.querySelector('[data-creator-noindex]')) return;
    if (document.querySelector('meta[name="robots"][content*="noindex"]')) return;
    var meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
  }

  function init() {
    initCopyButtons();
    initEmbeds();
    initSticky();
    initNoindex();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
